import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Navigation from "@/components/Navigation/Navigation";
import ServicesHeader from "@/components/ServicesHeader/ServicesHeader";
import ServicesListing from "@/components/ServicesListing/ServicesListing";
import useServices from "@/hooks/useServices";
import ServiceDrawer from "@/components/ServiceDrawer/ServiceDrawer";
import { resetExistService, setSelectedService } from "@/store/service/service";
import ModalDialog from "@/components/ModalDialog/ModalDialog";
import useDeleteEntity from "@/hooks/useDeleteEntity";
import { deleteService } from "@/store/service/service";
import { RootState } from "@/store/store";
import { setIsVisibleModalDialog } from "@/store/ui/ui";

import "@/shared/styles/layout.scss";

export default function ServicesPage() {
    const [open, setOpen] = useState<boolean>(false);
    const dispatch = useDispatch();
    const {
        data,
        dataLength,
        handleChange,
        query,
        handleChangeCategory,
        category,
        isLoading,
    } = useServices();
    const { handleDelete } = useDeleteEntity();
    const selectedServiceId = useSelector(
        (state: RootState) => state.services.selectedServiceId,
    );
    const serviceData = useSelector(
        (state: RootState) => state.services.serviceData,
    );
    let serviceTitle = "";

    if (selectedServiceId.length > 0) {
        const selectedData = serviceData.filter(
            item => item._id === selectedServiceId,
        );
        serviceTitle = selectedData[0].title;
    }

    function toggleDrawer(isOpen: boolean): void {
        if (!isOpen) {
            dispatch(resetExistService());
        }
        setOpen(isOpen);
    }
    async function handleDeletePatient() {
        function handleDeleteService() {
            dispatch(deleteService(selectedServiceId));
            dispatch(setIsVisibleModalDialog(false));
            dispatch(setSelectedService(""));
        }
        await handleDelete({
            entity: "services",
            id: selectedServiceId,
            onSuccess: handleDeleteService,
            message: "Послуга успішно видалена",
            isLocalLoading: true,
        });
    }

    return (
        <div className='container patients_container'>
            <Navigation />
            <ServicesHeader
                category={category}
                handleChange={handleChange}
                handleChangeCategory={handleChangeCategory}
                data={data}
                query={query}
                toggleDrawer={toggleDrawer}
            />
            <ServicesListing
                data={data}
                dataLength={dataLength}
                category={category}
                isLoading={isLoading}
                toggleDrawer={toggleDrawer}
                query={query}
            />
            <ServiceDrawer open={open} toggleDrawer={toggleDrawer} />
            <ModalDialog
                onConfirm={handleDeletePatient}
                title='Видалити послугу?'
                message={`Ви впевнені, що хочете видалити послугу ${serviceTitle}`}
                onCansel={() => dispatch(setSelectedService(""))}
            />
        </div>
    );
}
